// src/components/AboutHero.jsx
import { PNG } from "../../../utils/images";
import styles from "./herosection.module.css";


export default function AboutHero({ title }) {
  return (
    <section className={styles["about-hero"]}>
      <div className={styles["about-hero__inner"]}>
        {/* Left Section (Logo + Text) */}
        <div className={styles["about-hero__left"]}>
          <h3>IIT WOMEN</h3>
          <h3>FACULTY MEET</h3>
          <h3>2025</h3>

          <div className={styles["about-hero__logos"]}>
            <img
              src={PNG.iitd_white}
              alt="IIT Delhi Logo"
              className={styles["about-hero__logo1"]}
            />
            <img
              src={PNG.outreach_logo}
              alt="Outreach Logo"
              className={styles["about-hero__logo2"]}
            />
          </div>
        </div>

        {/* Center Title */}
        <div className={styles["about-hero__title"]}>{title}</div>

        {/* Right Background Image */}
        <img
          src={PNG.bg_transparent}
          alt="Decorative background"
          className={styles["about-hero__image"]}
        />
      </div>
    </section>
  );
}
